var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { SliceEventList } from '../entities/slice-event-list';
import { classNames } from '../../utils/cn';
import { usePastEvents } from '../../hooks/use-events';
var cls = classNames('slice-layout-past-events');
export var SlicePastEventsDefaultProps = {
  maxRowCount: 5
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
}); // -------- Components -------->

var My = {
  Container: styled(SliceEventList)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var SlicePastEvents = function SlicePastEvents(props) {
  var className = props.className,
      entity = props.entity;
  var events = usePastEvents();
  return React.createElement(My.Container, {
    events: events,
    className: cls.name(className)
  });
};
SlicePastEvents.defaultProps = SlicePastEventsDefaultProps;
SlicePastEvents.cls = cls;
var templateObject_1, templateObject_2;